module.exports = __webpack_public_path__ + "img/Eurocidade2020.b99f4c28.png";